import React from "react";
import "./certificateCard.css";
import { FaMedal } from "react-icons/fa";

function CertificateCard(props) {
  return (
    <div className="text-textColor dark:text-darkTextColor shadow-sm relative bg-bodyColor dark:bg-darkContainerColor dark:border-[1px] border-leetcodeBorderColor flex flex-col min-h-[16rem] max-w-[16rem]  w-full  rounded-2xl  group ">
      <div
        className="w-[90%] h-full  absolute left-1/2 bottom-[13%] -translate-x-1/2 -translate-y-2
      group-hover:skew-y-[10deg]  group-hover:skew-x-[0deg]  group-hover:bottom-[40%] transition-all duration-200 rounded-xl"
      >
        <img
          className="w-full h-full rounded-xl"
          src={props.img}
          alt="achievement"
        />
      </div>
      <div className="flex flex-col  items-center w-[100%] h-[80%] rounded-3xl bg-bodyColor dark:bg-darkContainerColor dark:border-t-2 border-leetcodeBorderColor  absolute bottom-[0%]  rounded-t-[40%] ">
        <FaMedal className="text-4xl text-firstColor" />
        <div className="flex flex-col justify-center items-center pt-6">
          <span className="section__contentSubTitle text-lg dark:text-white capitalize px-1 text-center">
            {props.title}
          </span>
          <ul className=" flex flex-col  justify-center list-[circle] pt-2 capitalize">
            <li>{props.platform}</li>
            <li>{`Issued on ${props.issued}`}</li>
          </ul>
          <a
            target="_blank"
            href={props.credential}
            className="my-2 px-3   rounded-lg border-[1px] shadow-md border-leetcodeBorderColor capitalize lg:cursor-pointer"
          >
            Show Credential
          </a>
        </div>
      </div>
    </div>
  );
}

export default CertificateCard;
